module.exports = __webpack_public_path__ + "static/media/apxor_app.cc7e0c44.png";